import { ampersandList } from "@edgetier/client-components";
import { ILanguage } from "@edgetier/watchtower-types";

/**
 * Create a list of language names using the iso codes passed.
 * @param languageIsoCodes      List of languages passed as iso codes.
 * @param languages             All languages with details.
 * @returns A list of language names.
 * @example "English & French".
 * @example "English & 2 more".
 * @example "All languages".
 */
export const createLanguageList = (languageIsoCodes: string[] | null, languages: ILanguage[]) => {
    if (languageIsoCodes !== null && languageIsoCodes.length > 0) {
        if (languages.length > 0) {
            const groupLanguages = languages
                .filter((language) => languageIsoCodes.includes(language.languageIsoCode))
                .map((language) => language.language);

            // All languages are selected
            if (groupLanguages.length === languages.length) {
                return "All";
            }

            if (groupLanguages.length <= 2) {
                return ampersandList(groupLanguages, { sort: true });
            } else {
                const [firstLanguage, ...otherLanguages] = groupLanguages.sort((one: string, two: string) =>
                    one.toLowerCase().localeCompare(two.toLowerCase())
                );
                return `${firstLanguage} & ${otherLanguages.length} more`;
            }
        }
    }

    return "All";
};
